// Marketplaces an order can be synced from, keyed by
// order_market_place_details.market.
const MARKETPLACES = {
  Shopify: {
    label: "Shopify",
    className: "bg-state-success-bg text-state-success-text",
  },
  Woocommerce: {
    label: "WooCommerce",
    className: "bg-state-purple-bg text-state-purple-text",
  },
};

export const marketplaceOf = (row) => {
  const market = row?.order_market_place_details?.market;
  if (!market) return null;
  return (
    MARKETPLACES[market] ?? {
      label: market,
      className: "bg-state-neutral-bg text-state-neutral-text",
    }
  );
};
